<template>
    <div class="container shop-container pt-4">
        <shop-heading ref="heading" :shop="shop"/>
        <div class="row">
            <div class="col-auto shop-sidebar">
                <shop-sidebar :shop="shop" />
            </div>
            <div class="col p-0">
                <shop-header :shop="shop" />
                <router-view ref="page" :shop="shop" @mounted="pageMounted" />
            </div>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route, get } from "@utils/network";
import ShopHeading from "./partials/ShopHeading";
import ShopHeader from "./partials/ShopHeader";
import ShopSidebar from "./partials/ShopSidebar";

import '@styles/customer.css';
import '@styles/table.css';

export default {
    name: "ShopsPage",
    components: {
        ShopHeading, ShopSidebar, ShopHeader
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },

    data: () => ({
        shop: {},
    }),

    methods: {
        initializeShop() {
            if (this.$route.params.id) {
                return this.fetchShopData(this.$route.params.id);
            }
            this.emmitShopInitialization();
        },

        fetchShopData(id) {
            get(route("shops/:id/profile", { id }))
                .then(response => {
                    this.shop = response.data.result.shop;
                    this.emmitShopInitialization();
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors("Please reload the page");
                })
        },

        emmitShopInitialization() {
            if (this.$refs.page && this.shop.id) {
                this.$refs.page.initialize(this.shop);
            }
        },
        
        pageMounted() {
            this.emmitShopInitialization();
        },
    },

    mixins: [mixins],

    mounted() {
        this.initializeShop();
    }
};
</script>
<style scoped>
.shop-sidebar {
    display: none;
    width:200px
}
.shop-header {
    display: block;
}
@media (min-width: 992px) {
    .shop-sidebar {
        display: inline-block;
    }
    .shop-header {
        display: none;
    }
}
</style>